import { useMediaQuery } from '@hooks/use-media-query'
import { SolarEnergyCarousel } from './solar-energy-carousel'
import { SolarEnergyGrid } from './solar-energy-grid'

export const SolarEnergy = () => {
  const tailwindMDBreakpoint = useMediaQuery(768)

  return (
    <>{tailwindMDBreakpoint ? <SolarEnergyGrid /> : <SolarEnergyCarousel />}</>
  )
}
